import * as Sentry from '@sentry/react';

interface AuthContext {
  url: string;
  method?: string;
}

/**
 * accessToken が localStorage に無いまま「認証必須」リクエストが組み立てられたケースを記録する。
 *
 * breadcrumb として残すだけなので単独では Sentry に送られず、
 * ヘッダー欠落による 401(DRF: 認証情報が含まれていません)などのエラー発生時に経緯を追う手がかりになる。
 */
export function reportMissingAccessToken({ url, method = 'GET' }: AuthContext): void {
  const hasRefreshToken = !!localStorage.getItem('refreshToken');

  Sentry.addBreadcrumb({
    category: 'auth',
    level: 'warning',
    message: 'Authorization header omitted (accessToken missing at request build)',
    data: { url, method, hasRefreshToken },
  });
}

/**
 * localStorage の accessToken を Authorization ヘッダーに付与する。
 * トークンが取得できない場合はヘッダーを付けず、代わりに reportMissingAccessToken で記録する。
 */
export function applyAuthHeader(headers: Headers, context: AuthContext): void {
  const token = localStorage.getItem('accessToken');
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
    return;
  }
  reportMissingAccessToken(context);
}
